import {OrderDetail} from 'new-models';
import {createContext} from 'react';

export interface IOrderXContext {
    orderData: OrderDetail | null;
    isOrderLoading?: boolean;
}

export const OrderXPageContext = createContext<IOrderXContext>({} as IOrderXContext);
